/*
 * Theme fallback values are maintained manually based on additions in the Figma script manifest
 * at https://github.com/EverlongProject/genesis-figma-script/blob/main/src/manifest.json
 */

export const fallbackTokens: { [key: string]: any } = {
  'borderRadii.card': 'borderRadii.medium',
  'borderRadii.progressBar': 'borderRadii.circle',
  'borderRadii.tags': '4',
  'borderWidths.card': 'borderWidths.thin',
  'colors.input.background.default': 'colors.interactive.background.default',
  'colors.input.background.disabled': 'colors.interactive.background.disabled',
  'colors.input.background.hovered': 'colors.interactive.background.hovered',
  'colors.input.background.pressed': 'colors.interactive.background.pressed',
  'colors.input.border.critical': 'colors.interactive.border.critical.default',
  'colors.input.border.default': 'colors.interactive.border.default',
  'colors.input.border.disabled': 'colors.interactive.border.disabled',
  'colors.input.border.hovered': 'colors.interactive.border.hovered',
  'colors.input.border.success': 'colors.success.border.default',
  'colors.input.border.warning': 'colors.warning.border.default',
  'colors.onSurface.border.card': 'colors.onSurface.border.subdued',
  'colors.surface.screenHeader.background':
    'colors.surface.background.tertiary',
  'colors.surface.skeleton.shimmer.background': '#E7E7E7FF',
  'colors.surface.skeleton.shimmer.overlay':
    'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)',
  'colors.tag.critical.background.bold': '#DD0E0EFF',
  'colors.tag.critical.background.subdued': '#F9E1E2FF',
  'colors.tag.critical.border.bold': '#DD0E0EFF',
  'colors.tag.critical.border.subdued': '#F9E1E2FF',
  'colors.tag.critical.text.bold': '#FFFFFFFF',
  'colors.tag.critical.text.subdued': '#BB1111FF',
  'colors.tag.four.background.bold': '#870644FF',
  'colors.tag.four.background.subdued': '#F2E1F0FF',
  'colors.tag.four.border.bold': '#870644FF',
  'colors.tag.four.border.subdued': '#F2E1F0FF',
  'colors.tag.four.text.bold': '#FFFFFFFF',
  'colors.tag.four.text.subdued': '#1A1A1AFF',
  'colors.tag.informational.background.bold': '#2E5CDFFF',
  'colors.tag.informational.background.subdued': '#E8F8FFFF',
  'colors.tag.informational.border.bold': '#2E5CDFFF',
  'colors.tag.informational.border.subdued': '#E8F8FFFF',
  'colors.tag.informational.text.bold': '#FFFFFFFF',
  'colors.tag.informational.text.subdued': '#225ECEFF',
  'colors.tag.neutral.background.bold': '#3B3B3BFF',
  'colors.tag.neutral.background.subdued': '#E9E9E9FF',
  'colors.tag.neutral.border.bold': '#3B3B3BFF',
  'colors.tag.neutral.border.subdued': '#E9E9E9FF',
  'colors.tag.neutral.text.bold': '#FFFFFFFF',
  'colors.tag.neutral.text.subdued': '#1A1A1AFF',
  'colors.tag.one.background.bold': '#501CD2FF',
  'colors.tag.one.background.subdued': '#EDEAF5FF',
  'colors.tag.one.border.bold': '#501CD2FF',
  'colors.tag.one.border.subdued': '#EDEAF5FF',
  'colors.tag.one.text.bold': '#FFFFFFFF',
  'colors.tag.one.text.subdued': '#1A1A1AFF',
  'colors.tag.success.background.bold': '#008A09FF',
  'colors.tag.success.background.subdued': '#E3F7F0FF',
  'colors.tag.success.border.bold': '#008A09FF',
  'colors.tag.success.border.subdued': '#E3F7F0FF',
  'colors.tag.success.text.bold': '#FFFFFFFF',
  'colors.tag.success.text.subdued': '#02692BFF',
  'colors.tag.three.background.bold': '#994000FF',
  'colors.tag.three.background.subdued': '#F2EEE6FF',
  'colors.tag.three.border.bold': '#994000FF',
  'colors.tag.three.border.subdued': '#F2EEE6FF',
  'colors.tag.three.text.bold': '#FFFFFFFF',
  'colors.tag.three.text.subdued': '#1A1A1AFF',
  'colors.tag.two.background.bold': '#135D03FF',
  'colors.tag.two.background.subdued': '#DEEADCFF',
  'colors.tag.two.border.bold': '#135D03FF',
  'colors.tag.two.border.subdued': '#DEEADCFF',
  'colors.tag.two.text.bold': '#FFFFFFFF',
  'colors.tag.two.text.subdued': '#1A1A1AFF',
  'colors.tag.warning.background.bold': '#B85B0FFF',
  'colors.tag.warning.background.subdued': '#FAE8D6FF',
  'colors.tag.warning.border.bold': '#B85B0FFF',
  'colors.tag.warning.border.subdued': '#FAE8D6FF',
  'colors.tag.warning.text.bold': '#FFFFFFFF',
  'colors.tag.warning.text.subdued': '#9F3703FF',
  'spacing.eighth': '2',
};
